export default __webpack_public_path__ + "static/moment_1-9981d1ced2e848c31ce94ca88e5670dd.jpg";